import {
  type IWebAnalyticsGap,
  type TWebAnalyticsFilterName,
} from '@mahawi/eshop-common';
import { Alert } from 'antd';
import React from 'react';

export const MAX_LISTED_GAP_DATES = 5;

export const describeGap = ({ provider, dates }: IWebAnalyticsGap): string => {
  const listed = dates.slice(0, MAX_LISTED_GAP_DATES).join(', ');
  const rest = dates.length - MAX_LISTED_GAP_DATES;

  return rest > 0
    ? `${provider}: ${listed} and ${rest} more`
    : `${provider}: ${listed}`;
};

function GapNote({
  gaps,
  ignoredFilters,
}: {
  gaps: IWebAnalyticsGap[];
  ignoredFilters: TWebAnalyticsFilterName[];
}): React.ReactElement | null {
  const withDates = gaps.filter(
    (gap: IWebAnalyticsGap): boolean => gap.dates.length > 0,
  );

  if (withDates.length === 0 && ignoredFilters.length === 0) {
    return null;
  }

  return (
    <Alert
      type="warning"
      showIcon
      title="Incomplete data"
      description={
        <>
          {withDates.map((gap: IWebAnalyticsGap): React.ReactElement => (
            <div key={gap.provider}>Missing days — {describeGap(gap)}</div>
          ))}
          {ignoredFilters.length > 0 ? (
            <div>Filters not applicable here: {ignoredFilters.join(', ')}</div>
          ) : null}
        </>
      }
    />
  );
}

export default GapNote;
